import { Controller } from '@hotwired/stimulus'

/*
 * DDT-4126 (design review): the name and status of the conversation header
 * (messages/parts/messages-conversation-card-title.html.twig). The status label shows only
 * when it fits next to the whole name; otherwise it hides (the coloured icon stays, as on
 * mobile) and only then does the name start to truncate. The label is never cut. How much
 * room there is depends on the name's length and on which columns are open, so it is measured:
 * again when the header resizes and when messages.js swaps the status (a new message arrives).
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['name', 'status']

    connect() {
        this.resizeObserver = new ResizeObserver(() => this.fit())
        this.resizeObserver.observe(this.element.parentElement)

        if (this.hasStatusTarget) {
            this.mutationObserver = new MutationObserver(() => this.fit())
            this.mutationObserver.observe(this.statusTarget, { childList: true, subtree: true })
        }

        this.fit()
    }

    disconnect() {
        this.resizeObserver?.disconnect()
        this.mutationObserver?.disconnect()
    }

    fit() {
        if (!this.hasStatusTarget || !this.hasNameTarget) {
            return
        }

        // Measure with the label on: if the name then has to truncate, the label goes.
        this.element.classList.remove('messages-title-main--no-label')

        const label = this.statusTarget.querySelector('.conversation-status__label')

        if (!label || getComputedStyle(label).display === 'none') {
            return
        }

        this.element.classList.toggle('messages-title-main--no-label', this.isNameTruncated())
    }

    // Sub-pixel: scrollWidth and clientWidth are rounded, so a name 0.4px too wide for its
    // box reads as fitting while the browser already draws the ellipsis.
    isNameTruncated() {
        const range = document.createRange()
        range.selectNodeContents(this.nameTarget)

        return range.getBoundingClientRect().width > this.nameTarget.getBoundingClientRect().width + 0.01
    }
}
